import React from "react";
import Waypoint from "react-waypoint";
import { withContentRect } from "react-measure";
import { inject, observer } from "mobx-react";
import styled from "react-emotion";

const Screen = styled.div`
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  flex-wrap: none;
  justify-content: center;
  align-items: center;
  ${props => props.styles};
`;

const getProgress = (ele, debug = false) => {
  if (!ele || typeof window === "undefined") {
    return null;
  }
  const rect = ele.getBoundingClientRect();
  const screenHeight = window.innerHeight;
  const inView =
    rect.top < screenHeight &&
    rect.bottom > 0 &&
    rect.bottom < screenHeight + rect.height;
  if (debug) {
    console.log(rect);
    console.log("TOP " + rect.top);
    console.log("BOTTOM " + rect.bottom);
    console.log("HIEGTH" + screenHeight);
    console.log("HIEGTH" + (screenHeight + rect.height));
    console.log("INVIEW" + inView);
    const dPer = 100 - rect.bottom / (screenHeight + rect.height) * 100;
    console.log("PER " + dPer);
  }
  if (inView) {
    return 100 - rect.bottom / (screenHeight + rect.height) * 100;
  } else {
    return null;
  }
};

class PageProgress extends React.Component {
  render() {
    return (
      <Screen
        styles={this.props.styles}
        innerRef={d => {
          this.container = d;
        }}
      >
        <div>
          {this.props.children({
            progress: getProgress(this.container, this.props.debug)
          })}
        </div>
      </Screen>
    );
  }
}

export default inject(({ store }) => ({
  scrollPos: store.uiStore.scroll.top
}))(observer(PageProgress));



// WEBPACK FOOTER //
// ./src/components/PageProgress/index.js